import { useMemo } from 'react';
import { DynamicIcon } from 'src/components';
import { useRegisterQuickActions } from 'src/components/QuickActions/use-register-quick-actions';
import { Address, Project } from 'src/graphql';
import { useProjectActions } from './use-project-actions';

const GROUP_NAME = 'Project Actions';

export const useProjectQuickActions = (project: Project) => {
  const {
    submitDay1,
    proposalWon,
    proposalLost,
    copyProjectId,
    copyProjectUrl,
    deleteProject,
  } = useProjectActions({ project, address: project.address as Address });

  useRegisterQuickActions(
    useMemo(
      () =>
        [
          copyProjectId,
          copyProjectUrl,
          { ...deleteProject, icon: 'delete_forever' },
          { ...proposalWon, icon: 'folder_check' },
          { ...proposalLost, icon: 'folder_limited' },
          { ...submitDay1, icon: 'folder_special' },
        ]
          .filter((action) => ('isAllowed' in action ? action.isAllowed : true))
          .map((action) => ({
            ...action,
            id: action.label,
            title: action.label,
            icon: action.icon ? <DynamicIcon name={action.icon} /> : null,
            group: GROUP_NAME,
          })),
      [copyProjectId, copyProjectUrl, deleteProject, proposalWon, proposalLost, submitDay1],
    ),
  );
};
